<ng-container *ngIf="sale && step && getVideoPath; else noVideoPath">
    <div class="d-flex flex-column gap-lg full-width">
        <h1 class="m-0">{{ step.title || step.name || 'Video' }}</h1>

        <p class="p1 lvl-1 m-0" *ngIf="step.settings!['description']">{{ step.settings!['description'] }}</p>

        <ng-container [ngSwitch]="getVideoType">
            <!-- YouTube Video -->
            <app-youtube-video-player *ngSwitchCase="'youtube'" (watched)="onWatched()"
                                      [youtubeVideoPath]="getVideoPath"></app-youtube-video-player>

            <!-- HTML Video -->
            <app-html-video-player *ngSwitchCase="'storage'" (watched)="onWatched()"
                                   [htmlVideoPath]="getVideoPath"></app-html-video-player>

            <!-- Fallback Content -->
            <ng-container *ngSwitchDefault>
                <p class="lvl-warning h3 text-center bold mt-5 mb-0">Unsupported video type</p>
            </ng-container>
        </ng-container>
    </div>
</ng-container>

<ng-template #noVideoPath>
    <p class="lvl-warning h3 text-center bold mt-5 mb-0">No Youtube Video ID or URL was Provided</p>
</ng-template>
